import React from "react";
import { useRouter } from "next/navigation";
import { HXCircleIcon, ImageKit } from "@aph/ui-lib-humanx";
import Slider, { Slide } from "@/components/Slider";
import IconRight from "$/icons/icon-right.svg";
import IconLeft from "$/icons/icon-left.svg";
import routes from "@/helpers/router";
import styles from "./ClusterWeekSelection.module.scss";
interface cardProps {
  iconUrl?: string;
  description?: string;
}

const ClusterWeekSelection = (props) => {
  const { data, userAgent, clusterSlug } = props;
  const { TitleOrDesc, Image, clusterList } = data;
  const router = useRouter();

  let currentSlide = clusterList?.findIndex((data) => data?.Slug === clusterSlug);

  const weekCard = (clusterData) => {
    const handleClusterClick = (slug) => {
      router.push(routes.cluster(slug));
    };

    if (!clusterData) {
      return <></>;
    }

    return (
      <a
        href={routes.cluster(clusterData?.Slug)}
        aria-label="babyLooLike Card"
        className={styles.anchorTag}
        onClick={(e) => e.preventDefault()}
      >
        <div
          className={`${styles.weekCard} ${clusterSlug === clusterData?.Slug ? styles.highlighted : ""}`}
          onClick={() => {
            handleClusterClick(clusterData?.Slug);
          }}
        >
          <div className={`${styles.weekNumber}`}> {clusterData?.ClusterNumber}</div>

          {userAgent?.isDesktop || (userAgent?.isMobile && clusterSlug === clusterData?.Slug) ? (
            <>
              <p className={styles.weeks}>
                {clusterData?.ClusterType}
                {clusterData?.ClusterNumber > 1 ? "s" : ""}
              </p>
            </>
          ) : null}
        </div>
      </a>
    );
  };

  const slidesToShow = userAgent?.isDesktop ? 9 : 5;

  const showingSlide = clusterList?.length - currentSlide > Math.floor(slidesToShow / 2);

  const defaultCurrentSlide =
    currentSlide - Math.floor(slidesToShow / 2) > 0
      ? showingSlide
        ? currentSlide - Math.floor(slidesToShow / 2)
        : clusterList?.length - slidesToShow
      : 0;

  return (
    <div className={`${styles.weekSelection} container spacingBetweenSections`}>
      <div className={styles.content}>
        <section data-testid={"WeekSlider"} className={styles.sliderSection}>
          <Slider
            autoplay={false}
            showArrows={userAgent?.isDesktop}
            dotsWrapperClass={styles.dotsWrapperClass}
            dotClass={styles.dotClass}
            dotClassActive={styles.dotClassActive}
            slidesToShow={slidesToShow}
            columnGap={userAgent?.isDesktop ? 14 : 20}
            nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
            prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
            showDots={false}
            slidesToScroll={1}
            defaultCurrentSlide={defaultCurrentSlide}
            // resetOnChildrenUpdate
          >
            {clusterList.map((clusterData, index) => {
              return (
                <Slide key={clusterData?.Slug} index={index}>
                  {weekCard(clusterData)}
                </Slide>
              );
            })}
          </Slider>
        </section>
        <div className={styles.iconAndDescription}>
          <div className={styles.iconWrapper}>
            <ImageKit src={Image?.data?.attributes?.url} width={158} height={158} alt="baby size" />
          </div>
          {TitleOrDesc && <div className={styles.description} dangerouslySetInnerHTML={{ __html: TitleOrDesc }} />}
        </div>
      </div>
      <div className={styles.bgStyle1}>
        <div className={styles.circle}></div>
      </div>
      <HXCircleIcon iconStyle="style2" className={styles.bgStyle2} />
    </div>
  );
};

export default ClusterWeekSelection;
